import InsightsLatestInsights from './InsightsLatestInsights';

export { type InsightsLatestInsightsProps } from './InsightsLatestInsights';
export default InsightsLatestInsights;
